import { ASSESSMENT_KIND_MAP } from 'services/assessments';
import { EditButton } from '@refinedev/antd';
import { FileDoneOutlined } from '@ant-design/icons';
import { Flex, Tabs, Tag } from 'antd';
import { IAssessment } from 'interfaces/assessments';
import { PageHeader } from 'components/professor_area/PageHeader';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { TabDiscursiveAttempts } from './components/tab_discursive_attempts/TabDiscursiveAttempts';
import { TabInfo } from './components/TabInfo';
import { TabObjectiveAttempts } from './components/tab_objective_attempts/TabObjectiveAttempts';
import { TabQuestions } from './components/TabQuestions';
import { useCustomSearchParams } from 'hooks/useSearchParams';
import { useShow } from '@refinedev/core';

export const AssessmentShow = () => {
  const { queryResult } = useShow<IAssessment>();
  const { currentSearchParams: currentTab, setSearchParams } =
    useCustomSearchParams({ searchParams: 'tab' });

  const { data, isLoading } = queryResult;
  const assessment = data?.data;

  return (
    <ShowLayout isLoading={isLoading}>
      <PageHeader
        title={assessment?.name}
        icon={FileDoneOutlined}
        meta={
          <Flex>
            {assessment?.kind && (
              <Tag>{ASSESSMENT_KIND_MAP[assessment?.kind]}</Tag>
            )}
          </Flex>
        }
        actions={<EditButton type="primary" />}
      />
      {assessment ? (
        <Tabs
          defaultActiveKey={currentTab || 'info'}
          onChange={tab => setSearchParams(tab)}
          className="custom-tabs"
        >
          <Tabs.TabPane tab="Informações gerais" key="info">
            <TabInfo assessment={assessment} />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Questões" key="questions">
            <TabQuestions />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Avaliações realizadas" key="attempts">
            {assessment.kind === 'objective' ? (
              <TabObjectiveAttempts />
            ) : (
              <TabDiscursiveAttempts />
            )}
          </Tabs.TabPane>
        </Tabs>
      ) : null}
    </ShowLayout>
  );
};
